import React, { useState } from 'react';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { message } from 'antd';
import { Form } from 'formik-antd';
import { FileExclamationOutlined } from '@ant-design/icons';
import { Box, Button, Flex } from 'atoms';
import { Debug } from 'components/forms/Debug';
import FilesUploadS3 from 'components/common/FilesUploadS3';
import { bulkUploadApi, getSampleDownload } from 'store/vendorBillSlice';
import { ActionAddButton, CancelButton, ErrorMessageBox } from 'utils/commonStyled';

const SampleAddButton = styled(Button)`
	background: #fff;
	color: #1890ff;
	border-radius: 4px;
`;

const filetypetoShow = 'CSV';
const fileformates = ['text/csv'];

export default function BulkUpload({ formData }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [odometerStartFilesList, setOdometerStartFilesList] = useState([]);
	const [errorFIle, seterrorFIle] = useState(true);
	const [responceSection, SetResponceSection] = useState(false);
	const [bulkData, setBulkData] = useState('');

	const FormSchema = Yup.object({
		upload_excel: Yup.array().label('Upload CSV'),
	});

	const initialValues = {
		trip_type: formData?.trip_type || undefined,
	};

	const handleSubmit = (setErrors) => {
		if (odometerStartFilesList.length > 0) {
			const key = odometerStartFilesList[0];

			dispatch(bulkUploadApi({ data_key: key, setErrors }))
				.then((res) => {
					SetResponceSection(true);
					setBulkData(res?.data);
				})
				.catch(() => {});
		} else {
			message.error('Please upload a CSV');
			seterrorFIle(true);
		}
	};

	function handleOdometerStartFileUpload(files) {
		console.log('handleOdometerStartFileUpload', files);
		setOdometerStartFilesList(files);
		seterrorFIle(false);
		console.log(errorFIle);
	}

	console.log('odometerStartFilesList', odometerStartFilesList);

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{({ values, errors }) => (
				<Box>
					<Form>
						{console.log('values', values)}
						{console.log('errors', errors)}
						<SampleAddButton type="button" onClick={() => getSampleDownload()}>
							{' '}
							Download Sample File
						</SampleAddButton>
						<Box padding="1.5rem 2rem" background="#fff">
							<Box border="1px solid #ccc" padding="34px">
								<FilesUploadS3
									entity="trip_bulk_upload"
									successCallBack={handleOdometerStartFileUpload}
									name="upload_excel"
									size={8192000}
									fileformates={fileformates}
									filetypetoShow={filetypetoShow}
								/>
							</Box>
							{errorFIle && <ErrorMessageBox>Upload CSV Required</ErrorMessageBox>}
						</Box>

						<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
							<CancelButton onClick={() => navigate('/trip-history')} type="button">
								Cancel
							</CancelButton>
							<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
								Submit
							</Button>
						</Box>
						{responceSection && (
							<Box margin="12px">
								<Box>
									<Flex>
										<Box margin="12px" color="green" fontSize="16px">
											{' '}
											Success Count:{' '}
											{bulkData?.success_count ||
												bulkData?.success_row ||
												0}{' '}
										</Box>
										<Box margin="12px" color="red" fontSize="16px">
											{' '}
											Error Count:{' '}
											{bulkData?.error_count || bulkData?.error_row || 0}{' '}
										</Box>
									</Flex>{' '}
								</Box>

								{(bulkData?.url || bulkData?.download_url) && (
									<a
										href={bulkData?.url || bulkData?.download_url}
										download={bulkData?.url || bulkData?.download_url}
										target="_blank"
									>
										<ActionAddButton primary type="button">
											<FileExclamationOutlined
												style={{
													fontSize: '16px',
													marginRight: '12px',
												}}
											/>
											Download Error file
										</ActionAddButton>
									</a>
								)}
							</Box>
						)}
						<Debug />
					</Form>
				</Box>
			)}
		</Formik>
	);
}

BulkUpload.propTypes = {
	formData: PropTypes.object,
};
